import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  connect() {
    this.element.addEventListener('lexxy:initialize', this.#insertTablesWithoutHeaders, { once: true })

    Promise.all([
      import('@37signals/lexxy'),
      import('lexxy-stylesheets/lexxy.css')
    ]).catch((error) => {
      this.element.insertAdjacentHTML('afterend', '<div class="text-danger small mt-1">The editor failed to load. Please refresh the page.</div>')
      this.application.handleError(error, 'Failed to load the Lexxy editor', { identifier: this.identifier })
    })
  }

  disconnect() {
    this.element.removeEventListener('lexxy:initialize', this.#insertTablesWithoutHeaders)
  }

  #insertTablesWithoutHeaders = async ({ target: { editor } }) => {
    const [{ COMMAND_PRIORITY_HIGH }, { INSERT_TABLE_COMMAND }] = await Promise.all([
      import('lexical'),
      import('@lexical/table')
    ])

    editor.registerCommand(INSERT_TABLE_COMMAND, (payload) => {
      if (!payload.includeHeaders) return false

      editor.dispatchCommand(INSERT_TABLE_COMMAND, { ...payload, includeHeaders: false })
      return true
    }, COMMAND_PRIORITY_HIGH)
  }
}
